import React from "react";

import { Routes, Route } from "react-router-dom";

import PageNotFound from "components/Common/PageNotFound";
import { MetaIQProvider } from "contexts/metaIQ";

import Classifications from "./Classifications";
import Results from "./Results";

const MetaIQ = () => (
  <MetaIQProvider>
    <Routes>
      <Route path="/" element={<Classifications />} />
      <Route path="/results" element={<Results />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  </MetaIQProvider>
);

export default MetaIQ;
